import { SinglePdfHeaderType } from "../GenericPdf/constant";

export const handleHeaderDescriptionWidth = (num: number) => {
  switch (num) {
    case 3:
      return "80%";
    case 4:
      return "70%";
    case 5:
      return "60%";
    case 6:
      return "55%";
    case 7:
      return "58%";
    default:
      return "35%";
  }
};

export const handleOthersWidth = (num: number) => {
  switch (num) {
    case 3:
      return "20%";
    case 4:
      return "18%";
    case 5:
      return "15%";
    case 6:
      return "14%";
    case 7:
      return "13%";
    default:
      return "12%";
  }
};

export const handleGstSummaryWidth = (num: number) => {

  switch (num) {
    case 4:
      return "25%";
    case 5:
      return "20%";
    default:
      return "25%";
  }
};

export const getMarginValue = (length: number): number => {
  switch (true) {
    case length === 13:
      return 92;
    case length === 12:
      return 75;
    case length === 11:
      return 60;
    case length === 10:
      return 50;
    case length === 9:
      return 35;
    case length === 8:
      return 12;
    case length === 4:
      return 35;
    case length === 5:
      return 28;
    case length === 6:
      return 40;
    case length === 7:
      return 70;
    default:
      return 20;
  }
};

export const getBatchMarginValue = (length: number): number => {
  switch (true) {
    case length === 13:
      return 40;

    default:
      return 22;
  }
};

export const checkingForHeaders = (data: any, tableHeaders: any, type?: string) => {
  let revenueTableHeaderData = [...tableHeaders];

  let shouldIncludeSkuCode = false;
  let shouldIncludeIgstAmount = false;
  let shouldIncludeCgstAmount = false;
  let shouldIncludeSgstAmount = false;
  let shouldIncludeGst = false;
  let shouldIncludeDiscount = false;
  let shouldIncludeHsnSac = false;
  let shouldIncludeRate = false;
  let shouldIncludeQuantity = false;
  let shouldIncludeAmount = false;
  let shouldIncludeTaxable = false;
  let shouldIncludeTotalValue = false;
  let shouldIncludeBatchSummary = false;

  data?.forEach((singleItem: any) => {
    if (!!singleItem?.sku_code && type != "withoutSku") shouldIncludeSkuCode = true;
    if (+singleItem?.igst_amount > 0) shouldIncludeIgstAmount = true;
    if (+singleItem?.cgst_amount > 0) shouldIncludeCgstAmount = true;
    if (+singleItem?.sgst_amount > 0) shouldIncludeSgstAmount = true;
    if (+singleItem?.gst_percentage > 0) shouldIncludeGst = true;
    if (+singleItem?.discount > 0) shouldIncludeDiscount = true;
    if (+singleItem?.hsn_sac_code > 0) shouldIncludeHsnSac = true;
    if (+singleItem?.rate > 0) shouldIncludeRate = true;
    if (+singleItem?.quantity > 0) shouldIncludeQuantity = true;
    if (+singleItem?.amount > 0) shouldIncludeAmount = true;
    if (+singleItem?.taxable_value > 0) shouldIncludeTaxable = true;
    if (+singleItem?.total_value > -1) shouldIncludeTotalValue = true;
    if (singleItem?.batch_number?.value > 0) shouldIncludeBatchSummary = true
  });

  if (!shouldIncludeSkuCode) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "sku_code"
    );
  }
  if (!shouldIncludeIgstAmount) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "igst_amount"
    );
  }
  if (!shouldIncludeCgstAmount) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "cgst_amount"
    );
  }
  if (!shouldIncludeSgstAmount) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "sgst_amount"
    );
  }
  if (!shouldIncludeGst) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) =>
        item.column_value !== "gst_percentage" &&
        item.column_value !== "cgst_amount" &&
        item.column_value !== "sgst_amount" &&
        item.column_value !== "igst_amount"
    );
  }
  if (!shouldIncludeDiscount) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "discount"
    );
  }
  if (!shouldIncludeHsnSac) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "hsn_sac_code"
    );
  }
  if (!shouldIncludeRate) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "rate"
    );
  }
  if (!shouldIncludeQuantity) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "quantity"
    );
  }
  if (!shouldIncludeAmount) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "amount"
    );
  }
  if (!shouldIncludeTaxable) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "taxable_value"
    );
  }
  if (!shouldIncludeTotalValue) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "total_value"
    );
  }
  if (!shouldIncludeBatchSummary) {
    revenueTableHeaderData = revenueTableHeaderData.filter(
      (item) => item.column_value !== "batch_id"
    );
  }

  return revenueTableHeaderData;
};

export const checkingForGstSummaryHeaders = (data: any, tableHeaders: SinglePdfHeaderType[]) => {
  let shouldIncludeIgstAmount = false;
  let gstSummaryHeaders = [...tableHeaders];

  data?.forEach((singleItem: any) => {
    if (+singleItem?.total_igst_amount > 0) shouldIncludeIgstAmount = true;
  });

  if (shouldIncludeIgstAmount) {
    gstSummaryHeaders = gstSummaryHeaders.filter(
      (item) =>
        item.column_value !== "total_cgst_amount" &&
        item.column_value !== "total_sgst_amount"
    );
  } else {
    gstSummaryHeaders = gstSummaryHeaders.filter(
      (item) => item.column_value !== "total_igst_amount"
    );
  }

  return gstSummaryHeaders
}
